

import React from "react";
import "../styles/Resume.css";
import { Link } from "react-router-dom";

const Resume = () => {
  return (
    <div className="resume-page">
      <h1>Craft a Winning Resume</h1>
      <p>Your resume is your first impression. Make it stand out!</p>

      <div className="resume-sections">
        <div className="resume-card">
          <h2>Resume Writing Tips 📄</h2>
          <p>✔ Keep it concise (1-2 pages).<br />
             ✔ Use bullet points for clarity.<br />
             ✔ Tailor it to the job description.<br />
             ✔ Use strong action verbs.</p>
        </div>

        <div className="resume-card">
          <h2>Sample Resumes 📌</h2>
          <p>Check out industry-specific resume samples.</p>
          <button className="secondary-btn">View Samples</button>
        </div>

        <div className="resume-card">
          <h2>Resume Mistakes to Avoid 🚫</h2>
          <p>❌ No spelling mistakes.<br />
             ❌ Avoid too much text.<br />
             ❌ Don't lie about your skills.<br />
             ❌ Use professional fonts.</p>
        </div>

      </div>

      <Link to="/resumebuilder" ><button >Create Your Resume</button></Link>
    </div>
  );
};

export default Resume;

















// import React from "react";
// import "../styles/Resume.css"; // Using a separate file to follow global styles
// import { Link } from "react-router-dom";

// const Resume = () => {
//   return (
//     <div className="resume-page">
//       <h1>Resume Tips & Samples</h1>
//       <p>Enhance your chances of getting hired with a professional resume.</p>

//       <div className="resume-sections">
//         <div className="resume-card">
//           <h2>Resume Writing Tips</h2>
//           <p>Learn how to structure your resume to highlight your strengths.</p>
//         </div>

//         <div className="resume-card">
//           <h2>Sample Resumes</h2>
//           <p>View sample resumes for different industries and experience levels.</p>
//         </div>

//         <div className="resume-card">
//           <h2>Resume Mistakes to Avoid</h2>
//           <p>Common pitfalls to avoid while creating your resume.</p>
//         </div>
//       </div>
//       <div >
//       <Link to="/resumebuilder" ><button >Create Your Resume</button></Link>
//       </div>
//     </div>
//   );
// };

// export default Resume;
